import React from 'react';

import { Icon } from '@chakra-ui/react';

export const IndividualAlertsIcon = props => (
  <Icon viewBox="0 0 57 57" color="inherit" h="full" w="full" {...props}>
    <g>
      <path
        d="M56.193,53.635L44.348,33.329c-0.405-0.695-1.128-1.11-1.934-1.11c-0.805,0-1.527,0.415-1.933,1.11L28.636,53.635
		c-0.409,0.7-0.412,1.539-0.008,2.242C29.033,56.58,29.758,57,30.569,57H54.26c0.811,0,1.536-0.42,1.939-1.123
		C56.604,55.174,56.601,54.336,56.193,53.635z M54.465,54.881C54.435,54.936,54.373,55,54.26,55H30.569
		c-0.114,0-0.175-0.064-0.206-0.119s-0.056-0.14,0.001-0.238l11.845-20.306c0.057-0.098,0.143-0.118,0.205-0.118
		c0.063,0,0.148,0.021,0.206,0.118l11.845,20.306C54.522,54.741,54.497,54.826,54.465,54.881z"
      />
      <path d="M42.499,39c-0.552,0-1,0.447-1,1v8c0,0.553,0.448,1,1,1s1-0.447,1-1v-8C43.499,39.447,43.052,39,42.499,39z" />
      <path
        d="M41.789,51.29c-0.18,0.189-0.29,0.449-0.29,0.71c0,0.26,0.11,0.52,0.29,0.71c0.19,0.189,0.44,0.29,0.71,0.29
		s0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.261-0.11-0.521-0.29-0.71C42.839,50.92,42.179,50.91,41.789,51.29z"
      />
      <path d="M27.499,12c-0.552,0-1,0.447-1,1s0.448,1,1,1h18c0.553,0,1-0.447,1-1s-0.447-1-1-1H27.499z" />
      <path d="M46.499,27c0-0.553-0.447-1-1-1h-18c-0.552,0-1,0.447-1,1s0.448,1,1,1h18C46.052,28,46.499,27.553,46.499,27z" />
      <path
        d="M21.079,7.241c-0.418-0.359-1.051-0.312-1.41,0.108l-6.248,7.288l-3.822-2.866c-0.443-0.331-1.069-0.242-1.4,0.2
		c-0.332,0.441-0.242,1.068,0.2,1.399L12.97,16.8c0.18,0.135,0.39,0.2,0.6,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-8
		C21.547,8.231,21.498,7.601,21.079,7.241z"
      />
      <path
        d="M21.079,21.241c-0.418-0.359-1.051-0.312-1.41,0.108l-6.248,7.288l-3.822-2.866c-0.443-0.331-1.069-0.242-1.4,0.2
		c-0.332,0.441-0.242,1.068,0.2,1.399L12.97,30.8c0.18,0.135,0.39,0.2,0.6,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-8
		C21.547,22.231,21.498,21.601,21.079,21.241z"
      />
      <path
        d="M19.669,36.35l-6.248,7.287l-3.822-2.866c-0.443-0.33-1.069-0.242-1.4,0.2c-0.332,0.441-0.242,1.068,0.2,1.399l4.571,3.429
		c0.18,0.135,0.39,0.2,0.6,0.2c0.283,0,0.563-0.119,0.76-0.35l6.857-7.999c0.359-0.419,0.311-1.05-0.108-1.409
		C20.661,35.882,20.028,35.93,19.669,36.35z"
      />
      <path
        d="M23.499,52H12.675C7.064,52,2.499,47.436,2.499,41.824V12.176C2.499,6.564,7.064,2,12.675,2h29.648
		c5.611,0,10.176,4.564,10.176,10.176v23.905c0,0.553,0.447,1,1,1s1-0.447,1-1V12.176C54.499,5.462,49.037,0,42.323,0H12.675
		C5.961,0,0.499,5.462,0.499,12.176v29.648C0.499,48.538,5.961,54,12.675,54h10.824c0.552,0,1-0.447,1-1S24.052,52,23.499,52z"
      />
    </g>
  </Icon>
);
